/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../pages/home.css";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null); // for desktop dropdowns

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle click outside for desktop dropdowns
  const backgroundRef = useRef(null);
  const toolsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        backgroundRef.current &&
        !backgroundRef.current.contains(event.target) &&
        toolsRef.current &&
        !toolsRef.current.contains(event.target)
      ) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (isMobile) {
    return (
      <div className="mobile-navbar">
        <Link to="/">
          <img
            src="/icons/TrueVoteLogo.png"
            alt="TrueVote"
            className="mobile-logo"
          />
        </Link>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {menuOpen && (
          <div className="mobile-menu">
            <Link to="/backgroundinfo">Background Info</Link>
            <Link to="/ask">Check a claim</Link>
            <Link to="/policy-swipe">Find your politician</Link>
            <Link to="/topics">See hot topics</Link>
            <Link to="/challenge">Test your digital literacy</Link>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="navbar">
      <Link to="/">
        <img
          src="/icons/TrueVoteLogo.png"
          alt="TrueVote"
          className="navbar-logo"
          style={{ cursor: "pointer" }}
        />
      </Link>

      <div className="nav-links">
        <div className="nav-item">
          <Link to="/" className="nav-text" style={{ cursor: "pointer" }}>
            Home
          </Link>
        </div>

        {/* Background Info dropdown */}
        <div className="nav-item nav-item-with-dropdown" ref={backgroundRef}>
          <div
            className="nav-text"
            onClick={() =>
              setOpenMenu(openMenu === "background" ? null : "background")
            }
            style={{ display: "inline-block", cursor: "pointer" }}
          >
            Background Info
            <span
              className={`dropdown-arrow ${
                openMenu === "background" ? "open" : ""
              }`}
            >
              ▾
            </span>
          </div>
          {openMenu === "background" && (
            <div className="dropdown-menu" style={{ display: "block" }}>
              <Link to="/backgroundinfo">Learn about voting system</Link>
              <Link to="/inforfrombackground">Learn about parliament</Link>
            </div>
          )}
        </div>

        {/* About Us
        <div className="nav-item">
          <span className="nav-text" style={{ cursor: "default" }}>
            About Us <span className="dropdown-arrow">▾</span>
          </span>
        </div> */}

        {/* Tools & Tips dropdown */}
        <div className="nav-item nav-item-with-dropdown" ref={toolsRef}>
          <div
            className="nav-text"
            onClick={() => setOpenMenu(openMenu === "tools" ? null : "tools")}
            style={{ display: "inline-block", cursor: "pointer" }}
          >
            Tools & Tips
            <span
              className={`dropdown-arrow ${openMenu === "tools" ? "open" : ""}`}
            >
              ▾
            </span>
          </div>
          {openMenu === "tools" && (
            <div className="dropdown-menu" style={{ display: "block" }}>
              <Link to="/ask">Check a claim</Link>
              <Link to="/policy-swipe">Find your politician</Link>
              <Link to="/topics">See hot topics</Link>
              <Link to="/challenge">Test your digital literacy</Link>
            </div>
          )}
        </div>

        {/* How It Works */}
        {/* <div className="nav-item">
          <span className="nav-text" style={{ cursor: "default" }}>
            How It Works? <span className="dropdown-arrow">▾</span>
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default Navbar;
